// extracted by mini-css-extract-plugin
export var dropdownContainer = "_pg-0";
export var leftAlign = "_pg-4";
export var listItem = "_pg-2";
export var listItemWrapper = "_pg-1";
export var operationText = "_pg-3";